/* eslint semi: 1 */
export const LICENSE_TYPES = {
  KIOSK: 'KIOSK',
  SYSTEMS: 'SYSTEMS',
  WIDGETS: 'WIDGETS'
};
